import React, { useState } from "react";
import { Steps, Button, message } from "antd";
import { Card, CardBody } from "reactstrap";
import {
  UserOutlined,
  SolutionOutlined,
  LoadingOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import Step1_Add from "./step1_add";
import Step2_add_System from "./step2_addSys";
import Step3_users_list from "./step3_usersList";
import Step3_rules from "./step3_rules";
import Step4_submission from "./step4_submission";

import AddFactoryIcon from "../../Assets/external_icons/color/add_fact_first.png";
import AddEquipmentIcon from "../../Assets/external_icons/color/add_fact_second.png";
import UsersAccessbilityIcon from "../../Assets/external_icons/color/add_fact_third.png";
import AccesptRulesIcon from "../../Assets/external_icons/color/add_fact_fourth.png";
import AccesptInformationIcon from "../../Assets/external_icons/color/add_fact_fifth.png";
import { useSelector } from "react-redux";

const { Step } = Steps;

const AddFact = () => {
  const lang_choiced = useSelector((state) => state.lang_change);

  const [current, setCurrent] = useState(0);

  const [step1, setStep1] = useState();
  const [step2, setStep2] = useState();
  // const [step3, setStep3] = useState();
  const [step4, setStep4] = useState();

  const finalData = [step1, step2, step4];
  const validation = (check) => {
    if (check === true) {
      next();
    }
  };
  const checkBack = (check) => {
    prev();
  };
  const controlledPrev = (count) => {
    // console.log("i am here");
    const newCurrent = current - count;
    setCurrent(newCurrent);
  };
  const getData = (data, step) => {
    switch (step) {
      case "step1":
        // console.log(data, "is final list 1");
        return setStep1(data);
      case "step2":
        // console.log(data, "is final list 2");
        return setStep2(data);
      // case "step3":
      // console.log(data, "is final list 3");
      // return setStep3(data);
      case "step4":
        // console.log(data, "is final list 4");
        return setStep4(data);
    }
  };

  const steps = [
    {
      title: lang_choiced.pages.add_fact.step1.title,
      icon: <img src={AddFactoryIcon} width={32} alt="AddFactoryIcon" />,
      content: <Step1_Add validation={validation} data={getData} />,
    },
    {
      title: lang_choiced.pages.add_fact.step2.title,
      icon: <img src={AddEquipmentIcon} width={32} alt="AddEquipmentIcon" />,
      content: (
        <Step2_add_System
          validation={validation}
          back={checkBack}
          data={getData}
        />
      ),
    },
    // {
    //   title: "دسترسی کاربران",
    //   icon: (
    //     <img
    //       src={UsersAccessbilityIcon}
    //       width={32}
    //       alt="UsersAccessbilityIcon"
    //     />
    //   ),
    //   content: (
    //     <Step3_users_list
    //       validation={validation}
    //       back={checkBack}
    //       data={getData}
    //     />
    //   ),
    // },
    {
      title: lang_choiced.pages.add_fact.step3.title,
      icon: <img src={AccesptRulesIcon} width={32} alt="AccesptRulesIcon" />,
      content: (
        <Step3_rules validation={validation} back={checkBack} data={getData} />
      ),
    },
    {
      title: lang_choiced.pages.add_fact.step4.title,
      icon: (
        <img
          src={AccesptInformationIcon}
          width={32}
          alt="AccesptInformationIcon"
        />
      ),
      content: (
        <Step4_submission
          back={checkBack}
          checkData={finalData}
          countBack={controlledPrev}
        />
      ),
    },
  ];

  function next() {
    const newCurrent = current + 1;
    setCurrent(newCurrent);
  }

  function prev() {
    const newCurrent = current - 1;
    setCurrent(newCurrent);
  }

  return (
    <Card className="p-4 animated fadeIn">
      <Steps style={{ direction: "ltr" }} current={current}>
        {steps.map((item, index) => (
          <Step
            key={item.title}
            title={
              <div
                style={{
                  color: index === current ? "#2196f3" : "black",
                  fontWeight: index === current ? "bold" : "normal",
                }}
              >
                {item.title}
              </div>
            }
            icon={item.icon}
          />
        ))}
      </Steps>
      <CardBody>
        <div className="steps-content">{steps[current].content}</div>
      </CardBody>
      {/* <Button onClick={()=>next()}>Next</Button> */}
    </Card>
  );
};

export default AddFact;
